export default "/_next/static/images/service-maxbone-mobile@3x-ad6b17689b6d06e6fe3ac812b88e742f.jpg";